import { BaseClass } from "./BaseClass";

export class ExtendedClient<T> extends BaseClass {
    client: T;

    constructor(ClientClass: new (baseUrl: string) => T) {
        super(process.env.REACT_APP_API_URL);
        this.client = new ClientClass(process.env.REACT_APP_API_URL||"");
    }
    getClient(): T {
        return this.client;
    }
}
